export default __webpack_public_path__ + "static/media/Markem-Imaje.8e4f2ec1.png";